import { TextRun, BorderStyle, AlignmentType, TableCell, Table, TableRow, VerticalAlign, Paragraph, WidthType, ShadingType } from "docx"

export const riskRating = new Paragraph({
    spacing: { before: 200, after: 250 },
    children: [
        new TextRun({
            text: "Risk Rating based on Severity:",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const riskRatingTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 20, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Rating",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "D9E2F3",
                    },

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 135,
                                after: 135
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Severity",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: {
                        type: ShadingType.SOLID,
                        color: "D9E2F3",
                    },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },

                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "C (Critical)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: {
                                left: 100,
                                right: 100
                            },
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            spacing: { line: 270 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Critical vulnerability has a high potential of impacting business operations leading to downtime or disruption and provides an attacker with privileged access, customer service or SLA breach resulting in significant outage. If exploited, it has a direct impact on confidentiality, integrity or availability of organizational information.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    color: "000000",
                                    bold: false
                                }),
                            ]
                        }),
                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                })
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "H (High)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })]
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "High vulnerability has a high potential of impacting business operations leading to downtime or disruption. This type of vulnerability can be exploited publicly, workaround or fix/patch available by vendor.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),

                            ]
                        }),

                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "M (Medium)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Medium vulnerability has a potential of indirectly giving access to an intruder and/or doesn't have the features enabled for collecting evidence or notifying the attacker of unauthorized use for taking the legal action in case the vulnerability gets exploited. This type of vulnerability upon exploitation might result in elevation of privileges or slowing down the operations.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),
                            ]
                        }),

                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "L (Low)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Low vulnerability has the potential of revealing the information about the device and may lead to unauthorized access to system leading to compromise. Higher work factor would be involved for exploiting this type of vulnerability.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),
                            ]
                        }),
                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "I (Informational)",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: {
                                before: 130,
                                after: 130
                            },
                            indent: {
                                left: 100,
                                right: 100
                            },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "These vulnerabilities are relatively very low risk or no risk but must be addressed in subsequent development cycle to avoid any future exposure.",
                                    font: "Arial",
                                    size: 24,
                                    italics: false,
                                    bold: false
                                }),
                            ]
                        }),
                    ],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                    },
                }),
            ]
        }),
    ]
})

export const exploitation = new Paragraph({
    spacing: { before: 700, after: 250 },
    children: [
        new TextRun({
            text: "Ease of Exploitation",
            size: 24,
            color: "2F5496",
            font: "Arial",
            bold: true,
            italics: false
        })
    ],
})

export const exploitationTable = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,

    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 20, type: WidthType.PERCENTAGE },

                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Easy",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    width: { size: 80, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.CENTER,

                    children: [
                        new Paragraph({
                            indent: { left: 80, right: 80 },
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires little-to-no technical/application knowledge on behalf of an attacker and can be exploited using standard operating system tools.",
                                    font: "Arial",
                                    size: 24,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Moderate",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: { left: 80, right: 80 },
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires some technical/application knowledge for an attacker to exploit, which could be performed using standard operating system tools or tools downloaded from the Internet.",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: "Difficult",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent: { left: 80, right: 80 },
                            spacing: { before: 80, after: 80 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Requires specific technical/application knowledge on behalf of an attacker. The issue could be exploited using a combination of operating system tools or publicly available tools downloaded from the Internet.",
                                    font: "Arial",
                                    size: 24,
                                    color: '000000',
                                    italics: false,
                                    bold: false
                                }),

                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                    },
                }),
            ]
        })
    ]
})